module.exports = __webpack_public_path__ + "static/logoBlack-9e59632a85ed6c4781fe958948e343d1.svg";